import React, { useEffect, useRef, useState } from "react";
import BackButton from "../components/microComponents/BackButton";
import { FaBars } from "react-icons/fa";
import { BiLeftArrow, BiRightArrow } from "react-icons/bi";
import { AiOutlineRetweet, AiOutlineClose } from "react-icons/ai";
import { SlVolume2 } from "react-icons/sl";
import { FaThumbsDown, FaThumbsUp, FaBookOpen } from "react-icons/fa";
import ShowAllQuestion from "../components/ShowAllQuestion/ShowAllQuestion";
import exam_board from "../assets/exam_borad_logo.png";
import facSimile from "../assets/fac_simile.png";
import scheda from "../assets/scheda_esame.png";
import logo from "../assets/logo.png";
import TimerView, { TimerViewRef } from "../components/TimerView/TimerView";
import { useParams, useSearchParams } from "react-router-dom";
import Urls from "../api/Urls";
import AnswerBtn from "../components/AnswerBtn/AnswerBtn";
import QuestionBtn from "../components/QuestionBtn/QuestionBtn";
import QuestionSpan from "../components/QuestionSpan/QuestionSpan";
import Utils from "../utils/Utils";
import scrollToTop from "../components/ScrollTop/ScrollTop";
import useUserStore from "../stores/useUserStore";
import CourseApi from "../api/services/CourseApi";
import PerformerApi from "../api/services/PerformerApi";
import QuestionApi from "../api/services/QuestionApi";
import useCourseStore from "../stores/useCourseStore";
import manik from "../assets/manik.png";
import { Swiper, SwiperSlide } from "swiper/react";
import Skeleton from "react-loading-skeleton";
import { Button, Modal } from "react-bootstrap";
import ZoomModal from "../components/microComponents/ZoomModal";
import SectionCard from "../components/SectionCard/SectionCard";
import useNavigationGuard from "../hooks/useNavigationGuard";

let currentAudio: any = null;

export interface Props {}

export const QuizExam: React.FC<Props> = (props) => {
  const { type } = useParams();
  const [searchParams] = useSearchParams();
  const qSetId = searchParams.get("qSetId");
  const viewOnly = searchParams.get("viewOnly");
  const isViewOnly = viewOnly === "true";
  const [isLoading, setIsLoading] = useState(false);
  const timerRef = useRef<TimerViewRef>(null);
  const user = useUserStore((state) => state.user);
  const originalQuizList = useCourseStore((state) => state.originalQuizList);
  const setOriginalQuizList = useCourseStore(
    (state) => state.setOriginalQuizList
  );
  const quizList = useCourseStore((state) => state.quizList);
  const setQuizList = useCourseStore((state) => state.setQuizList);
  const capitoliIds = useCourseStore((state) => state.capitoliIds);
  // const [showIndicator, setShowIndicator] = useState(false);
  const [showQuizListView, setShowQuizListView] = useState(false);
  const [showResultView, setShowResultView] = useState(false);
  const [isExamClosed, setIsExamClosed] = useState(false);
  const [selectedQuizIndex, setselectedQuizIndex] = useState(-1);
  const [wrongAnswer, setWrongAnswer] = useState(0);
  const [textList, setTextList] = useState<any[]>([]);
  // const [translateText, setTranslateObject] = useState("");
  // const [showTranslatePopover, setShowTranslatePopover] = useState(false);
  const quizBoxRef = useRef(null);
  const [showTimeExtenderModal, setShowTimeExtenderModal] = useState(false);
  const [showSection, setShowSection] = useState(false);
  const [section, setSection] = useState<any>({});

  // Navigation guard to prevent leaving during active quiz
  const shouldBlockNavigation = () => {
    // Block navigation if:
    // 1. Quiz is loaded and not yet closed
    // 2. User has started answering questions (at least one answer given)
    // 3. Timer is running (not exam closed)
    if (quizList.length > 0 && !isExamClosed) {
      const hasAnsweredQuestions = quizList.some(
        (quiz) => quiz.user_answer !== undefined
      );
      return hasAnsweredQuestions;
    }
    return false;
  };

  useNavigationGuard({
    when: shouldBlockNavigation(),
    message:
      "Are you sure you want to leave the quiz? Your progress will be lost and the exam will be closed.",
    onNavigationBlocked: () => {
      return window.confirm(
        "⚠️ Warning: You are about to leave the quiz exam!\n\n" +
          "If you leave now:\n" +
          "• Your current progress will be lost\n" +
          "• The exam will be automatically closed\n" +
          "• You'll need to start over\n\n" +
          "Are you sure you want to continue?"
      );
    },
  });

  useEffect(() => {
    // scrollToTop();
    // Scroll the window to the top of the quiz_box element
    if (quizBoxRef.current) {
      (quizBoxRef.current as HTMLDivElement).scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }

    fetchApiQuiz();

    return () => {
      window.speechSynthesis.cancel();
    };
  }, []);

  useEffect(() => {
    if (selectedQuizIndex >= 0 && quizList.length > 0) {
      let test = quizList[selectedQuizIndex]?.question;
      setTextList(test?.split(" "));
      // scrollRef.current?.scrollTo({x: selectedQuizIndex * 40});
    }
  }, [selectedQuizIndex, quizList]);

  const fetchApiQuiz = () => {
    if (type === "CUSTOM" || type === "QUESTIONSET") {
      setselectedQuizIndex(0);
      setWrongAnswer(0);
      setIsExamClosed(isViewOnly);
      setShowResultView(false);
      setShowQuizListView(false);
      if (timerRef.current && !isViewOnly) {
        timerRef?.current.resetTimer();
        timerRef?.current.startTimer();
      }
    } else if (type === "SIMULATION") {
      setIsLoading(true);
      CourseApi.getFinalQuizzes({
        onSuccess: (response) => {
          console.log("response", response);
          const formatedQuize = response.data.reduce(
            (result: any[], item: any) => [
              ...result,
              { ...item, answer: item.answer === "1" ? true : false },
            ],
            []
          );
          setOriginalQuizList(formatedQuize);
          setQuizList(JSON.parse(JSON.stringify(formatedQuize)));
          setselectedQuizIndex(0);
          setWrongAnswer(0);
          setIsLoading(false);
          setIsExamClosed(false);
          setShowResultView(false);
          setShowQuizListView(false);

          setTimeout(() => {
            if (timerRef.current) {
              timerRef?.current.resetTimer();
              timerRef?.current.startTimer();
            }
          }, 1000);
        },
        onError: () => setIsLoading(false),
      });
    } else if (type === "CAPITOLI") {
      setIsLoading(true);
      CourseApi.getChaptersQuizzes(
        { chapter: capitoliIds },
        {
          onSuccess: (response) => {
            // console.log("getChaptersQuizzes", response);
            const formatedQuize = response.data.reduce(
              (result: any[], item: any) => [
                ...result,
                { ...item, answer: item.answer === "1" ? true : false },
              ],
              []
            );
            setOriginalQuizList(formatedQuize);
            setQuizList(JSON.parse(JSON.stringify(formatedQuize)));
            setselectedQuizIndex(0);
            setWrongAnswer(0);
            setIsLoading(false);
            setIsExamClosed(false);
            setShowResultView(false);
            setShowQuizListView(false);

            setTimeout(() => {
              if (timerRef.current) {
                timerRef?.current.resetTimer();
                timerRef?.current.startTimer();
              }
            }, 1000);
          },
          onError: () => setIsLoading(false),
        }
      );
    }
  };

  const fetchSection = (id: number) => {
    CourseApi.getSectionDetails(id, {
      onSuccess: (response) => {
        setSection(response.data);
        setShowSection(true);
      },
      onError: () => {
        setSection({});
      },
    });
  };

  const onAnswerPressed = (answer: boolean) => {
    if (selectedQuizIndex < quizList.length) {
      const qesList = [...quizList];
      qesList[selectedQuizIndex].user_answer = answer;
      setQuizList(qesList);

      if (type !== "SIMULATION" && type !== "QUESTIONSET") {
        onNextPressed();
      }
    }
  };

  const onNextPressed = () => {
    if (selectedQuizIndex < quizList.length - 1) {
      setselectedQuizIndex(selectedQuizIndex + 1);
      window.speechSynthesis.cancel();
    }
  };

  const onPreviousPressed = () => {
    if (selectedQuizIndex > 0) {
      setselectedQuizIndex(selectedQuizIndex - 1);
      window.speechSynthesis.cancel();
    }
  };

  const onExamClosePressed = () => {
    const result = window.confirm(
      "Close exam? Are you sure to close the exam and see the result screen?"
    );

    if (result) {
      closeExam();
    }
  };

  const onPressedNewTab = () => {
    setselectedQuizIndex(-1);
    fetchApiQuiz();
  };

  const onRepeatPress = () => {
    setQuizList(JSON.parse(JSON.stringify(originalQuizList)));
    setselectedQuizIndex(0);
    setWrongAnswer(0);
    setIsExamClosed(false);
    setShowResultView(false);
    setShowQuizListView(false);
    if (timerRef.current) {
      timerRef?.current.resetTimer();
      timerRef?.current.startTimer();
    }
  };

  const closeExam = () => {
    filterChapterWiseResult([...quizList]);
    storeQuizPerformanceData([...quizList]);
    
    let makeAllAnswer = quizList.reduce((result, item) => {
      if (item.user_answer === undefined) {
        return [...result, { ...item, user_answer: !item.answer }];
      } else {
        return [...result, { ...item }];
      }
    }, []);

    // if there is question set id then only call api to save result
    if (type === "QUESTIONSET" && qSetId) {
      submitQuizResult([...makeAllAnswer]);
    }

    const wrongAnswer = makeAllAnswer.filter(
      (item: any) => item.user_answer !== item.answer
    );

    setQuizList(makeAllAnswer);
    setIsExamClosed(true);
    setShowResultView(true);
    setWrongAnswer(wrongAnswer.length);
    if (timerRef.current) {
      timerRef?.current.stopTimer();
    }
  };

  const filterChapterWiseResult = (results: any[]) => {
    const examResult = results.reduce((newResult: any[], obj) => {
      if (obj.user_answer !== undefined) {
        return [
          ...newResult,
          {
            quiz_id: obj.id,
            chapter_id: obj.chapter_id,
            correct_answer: obj.user_answer === obj.answer ? 1 : 0,
          },
        ];
      } else {
        return newResult;
      }
    }, []);

    // console.log("examResult", examResult);
    CourseApi.saveExamResult(
      { payload: examResult }
      // {
      //   showIndicator: true,
      //   onSuccess: response =>
      //     console.log(' saveExamResult response', response),
      //   onError: onError => console.log(' saveExamResult onError', onError),
      // },
    );
  };

  const submitQuizResult = (results: any[]) => {
    const examResult = results.reduce((newResult: any[], obj) => {
      if (obj.user_answer !== undefined) {
        return [
          ...newResult,
          {
            quiz_id: obj.id,
            given_answer: obj.user_answer === true ? "1" : "0",
            is_correct: obj.user_answer === obj.answer,
          },
        ];
      } else {
        return newResult;
      }
    }, []);

    QuestionApi.submitQuestionSetQuiz(
      { question_set_id: Number(qSetId), payload: examResult },
      {
        onSuccess: (response) =>
          console.log("saveExamResult response", response),
        onError: (onError) => console.log("saveExamResult onError", onError),
      }
    );
  };

  const storeQuizPerformanceData = (results: any[]) => {
    // Filter only answered questions
    const answeredQuestions = results.filter(
      (item) => item.user_answer !== undefined
    );

    // Calculate statistics
    const total_questions = results.length;
    const total_answered = answeredQuestions.length;
    const total_correct_answers = answeredQuestions.filter(
      (item) => item.user_answer === item.answer
    ).length;

    // Prepare payload
    const performanceData = {
      total_answered,
      total_correct_answers,
      total_questions,
    };

    // console.log("performanceData", performanceData);
    if (total_answered > 0) {
      PerformerApi.storeQuizPerformance(performanceData);
    }
  };

  const getShowResult = (quiz: any) => {
    let result = false;

    if (type === "SIMULATION" || type === "QUESTIONSET") {
      result = isExamClosed;
    } else {
      result = quiz?.user_answer !== undefined ? true : false;
    }

    return result;
  };

  const getAnswerMood = () => {
    let mood: "SELECTION" | "ANSWERED" = "SELECTION";
    if (type === "SIMULATION" || type === "QUESTIONSET") {
      mood = isExamClosed ? "ANSWERED" : "SELECTION";
    } else {
      mood =
        quizList[selectedQuizIndex]?.user_answer !== undefined
          ? "ANSWERED"
          : "SELECTION";
    }
    return mood;
  };

  const playAudio = (playUrl: string, speed: number = 1.0) => {
    if (currentAudio) {
      currentAudio.pause();
      currentAudio = null;
    }

    // console.log("audioUrl", Urls.storagePath + playUrl);
    const audio = new Audio(Urls.storagePath + playUrl);
    audio.playbackRate = speed;
    audio.play();
    currentAudio = audio;
  };

  const getBottomRightView = () => {
    if (showQuizListView) {
      return (
        <div
          className="click_box"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div className="finish_btn">
            <button
              className="chiudi_btn"
              onClick={() => setShowQuizListView(false)}
            >
              RITORNA ALLE DOMANDE
            </button>
          </div>
          {(type !== "QUESTIONSET" ||
            (type === "QUESTIONSET" && !isExamClosed)) && (
            <div className="finish_btn" style={{ marginTop: "10px" }}>
              <button
                className="chiudi_btn"
                onClick={isExamClosed ? onPressedNewTab : onExamClosePressed}
              >
                {isExamClosed ? "NUOVA SCHEDA" : "Chiudi Esame"}
              </button>
            </div>
          )}
        </div>
      );
    } else {
      return (
        <div
          className="click_box"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div className="clk_box">
            <div
              className="sub_click_box"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              {((type !== "SIMULATION" && type !== "QUESTIONSET") ||
                ((type === "SIMULATION" || type === "QUESTIONSET") &&
                  isExamClosed)) && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FaBookOpen
                    className="click_icons"
                    onClick={() => {
                      fetchSection(quizList[selectedQuizIndex]?.section_id);
                    }}
                  />
                </div>
              )}

              {quizList[selectedQuizIndex]?.quiz_audio && (
                <div style={{ display: "flex", alignItems: "center" }}>
                  <SlVolume2
                    className="click_icons"
                    onClick={() => {
                      playAudio(quizList[selectedQuizIndex]?.quiz_audio, 0.8);
                    }}
                  />
                </div>
              )}

              <div style={{ display: "flex", alignItems: "center" }}>
                <FaBars
                  className="click_icons"
                  onClick={() => setShowQuizListView(true)}
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <BiLeftArrow
                  className="click_icons"
                  onClick={onPreviousPressed}
                />
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                <BiRightArrow className="click_icons" onClick={onNextPressed} />
              </div>
            </div>
          </div>

          {isExamClosed ? (
            <div
              className="finish_btn"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              {type !== "QUESTIONSET" && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "15px",
                    }}
                  >
                    <AiOutlineRetweet
                      className="repeat_icon"
                      onClick={onRepeatPress}
                    />
                  </div>
                  <button
                    className="chiudi_btn"
                    onClick={onPressedNewTab}
                    style={{ flex: 1 }}
                  >
                    NUOVA SCHEDA
                  </button>
                </>
              )}
            </div>
          ) : (
            <div className="finish_btn" style={{ marginTop: "10px" }}>
              <button className="chiudi_btn" onClick={onExamClosePressed}>
                Chiudi Esame
              </button>
            </div>
          )}
        </div>
      );
    }
  };

  // console.log("quizList", quizList);
  return (
    <div className="Container pb-4">
      <BackButton title="Quiz" />
      {isLoading ? (
        skeleton
      ) : (
        <div className="quiz_page_main">
          <div className="quiz_box" ref={quizBoxRef}>
            <div className="qTopSec">
              <div className="exam_board">
                <img src={exam_board} alt="" />
                <span className="q_left_text">
                  <span className="mainText">
                    Ministero delle Infrastrutture <br />
                  </span>
                  <span>e dei Trasporti</span>
                  <span className="extra_text">
                    Dipartimento per i Trasporti, la Navigazione edi Sistemi
                    Informatii e Statistic Direzione Generale per la
                    Motorizzazione
                  </span>
                </span>
              </div>
              <div className="qT_img">
                <img src={scheda} alt="" />
              </div>
              <div className="qT_img">
                <img src={facSimile} alt="" />
              </div>
              <div className="qT_img">
                <img src={logo} alt="" />
              </div>
            </div>

            {/* large btn section */}
            <div className="domande_box">
              <div
                onClick={() => setselectedQuizIndex(0)}
                className={`dom_sec ${
                  selectedQuizIndex >= 0 && selectedQuizIndex < 10
                    ? "dom_sec_active"
                    : ""
                }`}
              >
                <span>Domande</span>
                <br />
                <span className="dom_sec_serial">da 1 a 10</span>
              </div>
              <div
                onClick={() => {
                  if (quizList.length > 10) {
                    setselectedQuizIndex(10);
                  }
                }}
                className={`dom_sec ${
                  selectedQuizIndex >= 10 && selectedQuizIndex < 20
                    ? "dom_sec_active"
                    : ""
                }`}
              >
                <span>Domande</span>
                <br />
                <span className="dom_sec_serial">da 11 a 20</span>
              </div>
              <div
                onClick={() => {
                  if (quizList.length > 20) {
                    setselectedQuizIndex(20);
                  }
                }}
                className={`dom_sec ${
                  selectedQuizIndex >= 20 && selectedQuizIndex < 30
                    ? "dom_sec_active"
                    : ""
                }`}
              >
                <span>Domande</span>
                <br />
                <span className="dom_sec_serial">da 21 a 30</span>
              </div>
            </div>

            {/* small static btn section */}
            <div className="page_serial">
              {quizList.map((item, index) => {
                if (
                  (selectedQuizIndex >= 0 &&
                    selectedQuizIndex < 10 &&
                    index >= 0 &&
                    index < 10) ||
                  (selectedQuizIndex >= 10 &&
                    selectedQuizIndex < 20 &&
                    index >= 10 &&
                    index < 20) ||
                  (selectedQuizIndex >= 20 &&
                    selectedQuizIndex < 30 &&
                    index >= 20 &&
                    index < 30)
                ) {
                  return (
                    <QuestionBtn
                      key={index}
                      onClick={() => setselectedQuizIndex(index)}
                      name={(index + 1).toString()}
                      type={(type as any) || "CUSTOM"}
                      isSelected={index === +selectedQuizIndex}
                      answer={quizList[index].answer}
                      isAnswered={quizList[index].user_answer}
                      showResult={getShowResult(quizList[index])}
                    />
                  );
                }
                return null;
              })}
            </div>

            <div className="quiz_serial">
              <Swiper
                slidesPerView={"auto"}
                spaceBetween={10}
                draggable={true}
                pagination={{
                  clickable: true,
                }}
              >
                {quizList.map((item, index) => (
                  <SwiperSlide
                    key={index}
                    style={{ width: "23.8px", marginRight: "3px" }}
                  >
                    {/* Adjust slide width as needed */}
                    <QuestionBtn
                      onClick={() => setselectedQuizIndex(index)}
                      name={(index + 1).toString()}
                      type={(type as any) || "CUSTOM"}
                      isSelected={index === selectedQuizIndex}
                      answer={quizList[index].answer}
                      isAnswered={quizList[index].user_answer}
                      showResult={getShowResult(quizList[index])}
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

            {showQuizListView ? (
              <div>
                <div className="answer_area">
                  <ShowAllQuestion
                    type={type}
                    questions={quizList}
                    isExamClosed={isExamClosed}
                  />
                </div>
              </div>
            ) : (
              <div className="quiz_area">
                <div className="left_area">
                  <div className="img">
                    <ZoomModal
                      img={
                        Urls?.storagePath +
                        quizList[selectedQuizIndex]?.media?.file_path
                      }
                    >
                      {quizList[selectedQuizIndex]?.media?.file_path && (
                        <img
                          src={
                            Urls.storagePath +
                            quizList[selectedQuizIndex]?.media?.file_path
                          }
                          alt=""
                        />
                      )}
                    </ZoomModal>
                  </div>
                </div>

                <div className="right_area">
                  <div className="q_info right_area_uper">
                    <div className="quiz_info">
                      {quizList.length > 0 && (
                        <div className="buttons">
                          <button
                            onClick={() => {
                              if (quizList[selectedQuizIndex]?.question_solution) {
                                Utils.showQuestionSolution(
                                quizList[selectedQuizIndex]?.question,
                                quizList[selectedQuizIndex]?.question_solution
                              );
                              } else {
                                Utils.translateFromGoogle(
                                quizList[selectedQuizIndex]?.question,
                                "bn"
                              )
                              }
                            }}
                            className="btnr warning sm"
                          >
                            বাংলা
                          </button>
                          <button
                            onClick={() =>
                              Utils.translateFromGoogle(
                                quizList[selectedQuizIndex]?.question,
                                "en"
                              )
                            }
                            className="btnr blue sm"
                          >
                            English
                          </button>

                          {quizList[selectedQuizIndex]?.quiz_voices && (
                            <div
                              className="img"
                              onClick={() =>
                                playAudio(
                                  quizList[selectedQuizIndex]?.quiz_voices
                                )
                              }
                            >
                              <img src={manik} alt="" />
                            </div>
                          )}
                        </div>
                      )}

                      <div className="infos">
                        <span>Domanda numero</span>
                        <span className="serial_quiz">
                          {selectedQuizIndex + 1}
                        </span>
                      </div>
                    </div>

                    {/* question word */}
                    <div className="question_box">
                      <div className="question">
                        {textList.map((word, index) => (
                          <QuestionSpan key={index} question={word} />
                        ))}
                        {/* <span
                          style={{ marginLeft: 20, color: "red" }}
                        >{`QId:${quizList[selectedQuizIndex]?.id}, SId:${quizList[selectedQuizIndex]?.section_id}`}</span> */}
                      </div>
                    </div>
                  </div>

                  <div className="right_area_bottom">
                    <AnswerBtn
                      type="VERO"
                      examType={(type as any) || "CUSTOM"}
                      mood={getAnswerMood()}
                      userAnswer={quizList[selectedQuizIndex]?.user_answer}
                      ignoreSelection={
                        quizList[selectedQuizIndex]?.user_answer === false
                      }
                      correctAnswer={quizList[selectedQuizIndex]?.answer}
                      onClick={() => onAnswerPressed(true)}
                    />
                    <AnswerBtn
                      type="FALSO"
                      examType={(type as any) || "CUSTOM"}
                      mood={getAnswerMood()}
                      userAnswer={quizList[selectedQuizIndex]?.user_answer}
                      ignoreSelection={
                        quizList[selectedQuizIndex]?.user_answer === true
                      }
                      correctAnswer={quizList[selectedQuizIndex]?.answer}
                      onClick={() => onAnswerPressed(false)}
                    />
                  </div>
                </div>
              </div>
            )}

            <div className="submit_area">
              <TimerView
                ref={timerRef}
                onTimerEnd={
                  type == "SIMULATION" || type == "QUESTIONSET"
                    ? closeExam
                    : () => {
                        if (timerRef.current) {
                          timerRef?.current.stopTimer();
                        }
                        setShowTimeExtenderModal(true);
                      }
                }
              />

              <div className="uper_scheda">
                {/* name and exam number */}
                <div className="Scheda_box">
                  <div>
                    <span>Cognome e Nome del Candidato</span>
                    <span>{`${user?.name}`}</span>
                  </div>
                </div>

                {/* icons view */}
                {getBottomRightView()}
              </div>
            </div>

            <div className="sb_mobile">
              {/* <div className="divBox">
              <span>Scheda Esame N.</span>
              <span>723</span>
            </div> */}
              <div className="divBox">
                <span>Cognome e Nome del Candidato</span>
                <span>{`${user?.name}`}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* tempo modal  */}
      <Modal
        show={showTimeExtenderModal}
        onHide={() => {
          setShowTimeExtenderModal(false);
          closeExam();
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
        className="tempoModal-main"
      >
        <Modal.Header>
          <Modal.Title>Time Extention</Modal.Title>
          <Button
            variant="light"
            onClick={() => {
              setShowTimeExtenderModal(false);
              closeExam();
            }}
            className="p-0 border-0 bg-transparent ms-auto"
            aria-label="Close"
          >
            <AiOutlineClose size={32} />
          </Button>
        </Modal.Header>
        <div className="tempoModal">
          <p>
            Tempo disponibile esaurito. Se si fosse in esame la scheda verrebbe
            chiusa, in automatico, e tutti i quesiti a cui non si e risposto
            verrrebbero contati come errore. <br /> <br /> Ma dato che Iattuale
            scheda non simula un eseme, viene concesso di proseguire.
          </p>
          <button
            onClick={() => {
              setShowTimeExtenderModal(false);
              if (timerRef.current) {
                timerRef?.current.resetTimer();
                timerRef?.current.startTimer();
              }
            }}
            className="btnr primary w-100"
          >
            Ok
          </button>
        </div>
      </Modal>

      <Modal
        show={showResultView}
        onHide={() => setShowResultView(false)}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Button
            variant="light"
            onClick={() => setShowResultView(false)}
            className="p-0 border-0 bg-transparent ms-auto"
            aria-label="Close"
          >
            <AiOutlineClose size={32} />
          </Button>
        </Modal.Header>

        <div className="exam_modal">
          {type !== "CUSTOM" && (
            <>
              <h2>{wrongAnswer > 3 ? "Non Superato!" : "Superato!"}</h2>
              <span>Hai fatto {wrongAnswer} errori</span>
              {wrongAnswer > 3 ? (
                <FaThumbsDown className="the_icon red_ans" />
              ) : (
                <FaThumbsUp className={`the_icon green_ans`} />
              )}
            </>
          )}

          <button
            onClick={() => setShowResultView(false)}
            className="btnr primary w-100"
          >
            RITORNA ALLE DOMANDE
          </button>
          {type !== "QUESTIONSET" && (
            <>
              <button onClick={onRepeatPress} className="btnr purple w-100">
                RIPTILA SCHEDA
              </button>
              <button onClick={onPressedNewTab} className="btnr w-100">
                NUOVA SCHEDA
              </button>
            </>
          )}
        </div>
      </Modal>

      <Modal
        show={showSection}
        onHide={() => setShowSection(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <AiOutlineClose
          size={32}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            cursor: "pointer",
            zIndex: 10,
          }}
          onClick={() => setShowSection(false)}
        />

        <div className="trafficoMain">
          <SectionCard
            key={section?.id}
            title={section?.section_title}
            desc={section?.section_desc}
            groups={section?.groups}
            mainImages={
              section?.mainMedia?.length > 0 ? section?.mainMedia[0] : undefined
            }
            optionalImages={section?.optionalMedia}
            isDisableGroupBtn
          />
        </div>
      </Modal>
    </div>
  );
};

const skeleton = (
  <>
    <div className="quiz_page_main skeleton">
      <div className="quiz_box">
        <div className="qTopSec">
          <div className="exam_board">
            <img src={exam_board} alt="" />
            <span className="q_left_text">
              <span className="mainText">
                Ministero delle Infrastrutture <br />
              </span>
              <span>e dei Trasporti</span>
              <span className="extra_text">
                Dipartimento per i Trasporti, la Navigazione edi Sistemi
                Informatii e Statistic Direzione Generale per la Motorizzazione
              </span>
            </span>
          </div>
          <div className="qT_img">
            <img src={scheda} alt="" />
          </div>
          <div className="qT_img">
            <img src={facSimile} alt="" />
          </div>
          <div className="qT_img">
            <img src={logo} alt="" />
          </div>
        </div>

        <div className="domande_box">
          <div className="dom_sec">
            <Skeleton />
            <Skeleton />
          </div>
          <div className="dom_sec">
            <Skeleton />
            <Skeleton />
          </div>
          <div className="dom_sec">
            <Skeleton />
            <Skeleton />
          </div>
        </div>

        <div className="page_serial">
          {Array.from({ length: 10 }).map((_, index) => (
            <Skeleton key={index} style={{ marginRight: "5px" }} />
          ))}
        </div>

        <div className="quiz_serial">
          <Swiper
            slidesPerView={"auto"}
            spaceBetween={10}
            draggable={true}
            pagination={{
              clickable: true,
            }}
          >
            {Array.from({ length: 20 }).map((_, index) => (
              <SwiperSlide key={index} style={{ width: "30px" }}>
                <Skeleton key={index} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="quiz_area">
          <div className="left_area">
            <div className="img">
              <Skeleton width="100%" height="100%" />
            </div>
          </div>

          <div className="right_area">
            <div className="q_info right_area_uper">
              <div className="quiz_info">
                <div className="buttons">
                  <Skeleton width={100} height={20} />
                  <Skeleton width={100} height={20} />

                  <div className="img">
                    <Skeleton circle={true} width={30} height={30} />
                  </div>
                </div>
              </div>

              {/* question word */}
              <div className="question" style={{ width: "100%" }}>
                {[...Array(6)].map((_, index) => (
                  <Skeleton width="100%" height={18} key={index} />
                ))}
                <Skeleton width="60%" height={18} />
              </div>
            </div>

            <div className="right_area_bottom">
              <Skeleton width={60} height={70} />
              <Skeleton width={60} height={70} />
            </div>
          </div>
        </div>

        <div className="submit_area">
          <div className="tempo_box">
            <div className="tempo">
              <span>
                <Skeleton width="100%" />
              </span>
              <span>
                <Skeleton width="100%" />
              </span>
            </div>
          </div>

          <div className="uper_scheda">
            {/* name and exam number */}
            <div className="Scheda_box">
              {/* <div>
                <span>Scheda Esame N.</span>
                <span>723</span>
              </div> */}
              <div>
                <span>
                  {" "}
                  <span>
                    <Skeleton width="100%" height={18} />
                  </span>
                </span>
                <span>
                  {" "}
                  <span>
                    <Skeleton width="50%" />
                  </span>
                </span>
              </div>
            </div>

            <div className="click_box">
              <div className="clk_box">
                <div className="sub_click_box skeleton">
                  <div>
                    <Skeleton width={45} height={45} circle={true} />
                  </div>
                  <div>
                    <Skeleton width={45} height={45} circle={true} />
                  </div>
                  <div>
                    <Skeleton width={45} height={45} circle={true} />
                  </div>
                  <div>
                    <Skeleton width={45} height={45} circle={true} />
                  </div>
                </div>
              </div>
              <div className="Scheda_box">
                <div>
                  <span style={{ background: "none" }}>
                    {" "}
                    <span>
                      <Skeleton width="100%" height={22} />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sb_mobile">
          <div className="divBox">
            <span>
              {" "}
              <span>
                <Skeleton width="100%" height={18} />
              </span>
            </span>
            <br />
            <span>
              {" "}
              <span>
                <Skeleton width="50%" />
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default QuizExam;
